import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { OpsVendorDailyRental } from './ops-vendor-daily-rental/ops-vendor-daily-rental';
import { OpsVendorWeeklyRental } from './ops-vendor-weekly-rental/ops-vendor-weekly-rental';
import { OpsVendorMonthlyRental } from './ops-vendor-monthly-rental/ops-vendor-monthly-rental';
import { ANGULAR_MODULES, SYNCFUSION_MODULES } from 'src/app/Shared/shared-imports';
import { firstValueFrom, lastValueFrom, Subscription, take, takeUntil } from 'rxjs';
import { VendorService } from 'src/app/services/Vendor.service';
import { WordReplacePipe } from 'src/app/Shared/word-replace.pipe';
import { RentalSettingService } from 'src/app/services/RentalSetting.service';
import { IRentalSettings } from 'src/app/Shared/Interfaces/IRentalSettings';
import { GeneralService } from 'src/app/services/general.service';
import { UserService } from 'src/app/services/User.service';
import { OperationRentalService } from 'src/app/services/Rentals.service';
import { PhoneFormatPipe } from 'src/app/Shared/phone-format.pipe';
import { ToastrService } from 'ngx-toastr';
import { SharedHTMLSettingsDataService } from 'src/app/Shared/sharedHTMLSettingsData.service';
declare var bootstrap: any;

@Component({
  selector: 'app-ops-vendor-rentals',
  standalone: true,
  imports: [ANGULAR_MODULES, SYNCFUSION_MODULES, OpsVendorDailyRental, OpsVendorMonthlyRental, OpsVendorWeeklyRental, WordReplacePipe, PhoneFormatPipe],
  templateUrl: './ops-vendor-rentals.html',
  styleUrl: './ops-vendor-rentals.scss'
})
export class OpsVendorRentals implements OnInit, OnDestroy {
  constructor(private vendorService: VendorService,
     private rentalService : RentalSettingService,
     private generalService : GeneralService,
     private opsRentalService : OperationRentalService,
     private toastr: ToastrService,
     private sharedHTMLSettings: SharedHTMLSettingsDataService,
     private userService : UserService
  ) {
  }

  @Input() vendorId;
  @Output() isFormDirty = new EventEmitter<any>(); 
  fromDate: string = '';
  toDate: string = '';
  hideTopHeaderDisplay;
  vendorInfo;
  includeReceipts: boolean = false;
  activeTab;
  vendorComments: string = "";
  finalvendorComment: string = "";
  rentalNotes: string = "";
  finalRentalNotes: string = "";
  vendorMarketID = "";
  marketId;
  vendorName = "";
  telephone = "";
  cellPhone = "";
  Email = "";
  Address = "";
  City = "";
  private subscriptions: Subscription[] = [];
  visibleTabs: any[] = [];
  dailyRentalPermission;
  combinedMonthlyRentalPermission;
  combinedWeeklyRentalPermission;
  displayCMRental = false;
  monthlyRentalEndDate;
  selectedEndDates = "";
  monthlyMarketDays;
  userPermission;
  isDirty = false;
  @Input() dayendOrOpenCashNotSaved;
  terminalNoSet = false;
  vendorIsInactive = false;

  tabs = [
    { key: 'Daily', label: 'Daily', typeId: '1' },
    { key: 'Weekly', label: 'Weekly', typeId: '5' },
    { key: 'Monthly', label: 'Monthly', typeId: '4' }
  ];

  ngOnInit(): void {
     this.getUserPermission();    
  }

  async getUserPermission() {
    const res = await firstValueFrom(this.generalService.GetUserPermission());
    if (res) {
      this.userPermission = res;
    }
    this.activeTab = 'Monthly';
    this.displayCMRental = this.activeTab == 'Monthly';
    this.getDefaultTerminalId();
    this.getUserAllowedRentalTypes();
    this.getVendorInfo();
    this.getMonthlyMarkets();
    this.getVendorComment();
    this.getDefaultRentalNotes();
  }

  getDefaultTerminalId() {
    this.userService.getDefaultTerminalId()
      .pipe(take(1))
      .subscribe(res => {
        if (res && res != 0) {
          this.terminalNoSet = false;
        } else {
           this.terminalNoSet = true;
          this.toastr.info($localize`User Default Terminal Not Set`, $localize`Info`, this.sharedHTMLSettings.ToasterConfig);
        }
      })
  }

  hideHeaders(value) {
    this.hideTopHeaderDisplay = value;
  }

  async getUserAllowedRentalTypes() {
    this.generalService.UserPermissions = await lastValueFrom(
      this.generalService.GetUserPermission().pipe(take(1))
    );

    var userRentalType = this.generalService.getUserRentalTypes();
    this.dailyRentalPermission = userRentalType.find(x => x.RentalTypeID == 1).RentalTypeAllowed;
    this.combinedMonthlyRentalPermission = userRentalType.find(x => x.RentalTypeID == 4).RentalTypeAllowed;
    this.combinedWeeklyRentalPermission = userRentalType.find(x => x.RentalTypeID == 5).RentalTypeAllowed;
    this.getRentalSettings();
  }

  checkSelectedEndDates() {
   if (this.displayCMRental)
      this.selectedEndDates = this.monthlyRentalEndDate;
  }

  getMonthlyMarkets() {
    this.opsRentalService.getMonthlyMarketDays().pipe(take(1)).subscribe({
      next: (res) => {
        if (res) {
          this.monthlyMarketDays = res;
          this.monthlyRentalEndDate = res[0].RentalMonths
        }
      }
    });
  }

  getRentalSettings(): void {
    this.rentalService.getRentalSettings().pipe(take(1)).subscribe({
      next: (data: IRentalSettings) => {
        const rentalSettings = data?.RentalTypesSettings.RentalTypes;

        if (rentalSettings) {
          const rentalTypesSelected = rentalSettings.split(',').map(x => x.trim());

          this.visibleTabs = this.tabs.filter(tab => {
            const isTypeAllowed = rentalTypesSelected.includes(tab.typeId);            
            if (!isTypeAllowed) return false;

            if (tab.typeId == '1') return this.dailyRentalPermission;
            if (tab.typeId == '4') return this.combinedMonthlyRentalPermission;
            if (tab.typeId == '5') return this.combinedWeeklyRentalPermission;

            // Default: allow
            return true;
          });
        } else {
          this.visibleTabs = [];
        }
      },
      error: (err) => {
        console.error('Error fetching rental settings:', err);
      }
    });
  }

  getVendorComment() {
    this.subscriptions.push(this.vendorService.getVendorComment(this.vendorId).subscribe((response) => {
      if (response) {
        this.finalvendorComment = response.body.Comment;
      }
    }));
  }

  getVendorInfo() {
    this.subscriptions.push(this.vendorService.GetVendorById(this.vendorId).subscribe((res: any) => {
      if (res) {
        this.vendorInfo = res;
        this.vendorMarketID = this.vendorInfo.MarketVendorId;
        this.vendorName = this.vendorInfo.VendorName;
        this.telephone = this.vendorInfo.Telephone;
        this.Email = this.vendorInfo.Email;
        this.Address = this.vendorInfo.Address;
        this.City = this.vendorInfo.City;
        this.vendorIsInactive = this.vendorInfo.IsInactive;
      }
    }, err => {
    }));
  }

  selectTab(tab: string): void {
    this.activeTab = tab;
    this.displayCMRental = this.activeTab == 'Monthly'; 
  }

  getDefaultRentalNotes() {
    const sub = this.opsRentalService.getDefaultRentalNotes().subscribe((response: string) => {
      if (response) {
       this.finalRentalNotes = response;
        //this.defaultRentalNotes = response;
      }
    },
      (err) => {
        console.error('Error in getDefaultRentalNotes', err);
      });
    this.subscriptions.push(sub);
  }

  setDirtyFlag(eve) {
    this.isDirty = eve;
    this.isFormDirty.emit(eve);
  }

  loadVendorComments() {
    this.finalvendorComment = this.vendorComments;
  }

  saveVendorComments() {
    var obj = {
      VendorId: this.vendorInfo.VendorId,
      Comment: this.vendorComments
    }
    this.vendorService.UpdateOrSaveVendorComment(obj).pipe(take(1)).subscribe((res: any) => {
      if (res.Success) {
        this.toastr.success($localize`Vendor comments saved successfully`, 'Success', this.sharedHTMLSettings.ToasterConfig);
      }
      else {
        this.toastr.error($localize`Error occured while saving vendor comments`, 'Error', this.sharedHTMLSettings.ToasterConfig)
      }
      this.getVendorComment();
    }, (err) => {
      this.toastr.error($localize`Error occured while saving vendor comments`, 'Error', this.sharedHTMLSettings.ToasterConfig);
    });
    this.closeModalById('modalVendorComments')
  }

  closeModalById(modalId: string) {
    const modalEl = document.getElementById(modalId);
    if (modalEl) {
      const modalInstance = window['bootstrap'].Modal.getInstance(modalEl);
      if (modalInstance) {
        modalInstance.hide();
      }
    }
    document.body.classList.remove('modal-open');

    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  }

  openModalById(modalId) {
    document.querySelectorAll('.modal-backdrop').forEach(e => e.remove());
    const modal = new bootstrap.Modal(
      document.getElementById(modalId)!,
      {
        backdrop: 'static',
        keyboard: false,
        focus: true
      }
    );
    modal.show();
  }

  saveRentalNotes() {
    this.finalRentalNotes = this.rentalNotes;
  }

  bindVendorComments() {
    this.vendorComments = this.finalvendorComment;
    this.openModalById('modalVendorComments');
  }

  bindRentalNotes() {
    this.rentalNotes = this.finalRentalNotes;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }
}
